module.exports = __webpack_public_path__ + "static/media/abs-active.7bc7ba7d.svg";